import { render, staticRenderFns } from "./VidjetWatermark.vue?vue&type=template&id=221ef700&scoped=true&"
import script from "./VidjetWatermark.vue?vue&type=script&lang=js&"
export * from "./VidjetWatermark.vue?vue&type=script&lang=js&"
import style0 from "./VidjetWatermark.vue?vue&type=style&index=0&id=221ef700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ef700",
  null
  
)

export default component.exports